import type { ComponentProps } from 'react'
import OccupancyPicker from 'components/Common/OccupancyPicker/OccupancyPicker'
import useCruiseVendorConfiguration from 'checkout/hooks/cruises/useCruiseVendorConfiguration'

type OccupancyPickerProps = ComponentProps<typeof OccupancyPicker>

interface Props extends Omit<
  OccupancyPickerProps,
  'allowPastPassengerNumber' | 'pastPassengerFieldsRequired' | 'personTitlesSupported'
> {
  departureId: string
}

function CruiseOccupancyPicker({ departureId, ...props }: Props) {
  const vendorConfiguration = useCruiseVendorConfiguration({ departureId })

  const isPastPassengerNumberLoading = !vendorConfiguration || vendorConfiguration.loading
  const pastPassengerFieldsRequired = vendorConfiguration?.pastPassengerFieldsRequired ?? []

  return (
    <OccupancyPicker
      {...props}
      allowPastPassengerNumber={!isPastPassengerNumberLoading && pastPassengerFieldsRequired.length > 0}
      isPastPassengerNumberLoading={isPastPassengerNumberLoading}
      pastPassengerFieldsRequired={pastPassengerFieldsRequired}
      personTitlesSupported={vendorConfiguration?.personTitlesSupported}
    />
  )
}

export default CruiseOccupancyPicker
